import http from "./httpService";
import { getJwt } from "./authService";
import { eventsType } from "../pages/EventSelection";

const perimeterKey = "perimeter";
const institutionIdKey = "institutionId";
const periodKey = "period";
const eventKey = "event";

export const EventSelctionService = (params: eventsType) => {
  http.setJwt(getJwt()!);
  localStorage.setItem(perimeterKey, params.perimeter);
  localStorage.setItem(institutionIdKey, params.institutionId);
  localStorage.setItem(periodKey, params.period);
  localStorage.setItem(eventKey, params.event);
};

export function getReportingParams() {
  const period = new Date(localStorage.getItem(periodKey)!);

  return {
    perimeter: localStorage.getItem(perimeterKey)!,
    institutionId: localStorage.getItem(institutionIdKey)!,
    event: localStorage.getItem(eventKey)!,
    period,
  };
}

export default EventSelctionService;
